import { ExpressionKinds } from "./ExpressionKinds";
import { ILinkedObjectSpecifiable } from "./ILinkedObjectSpecifiable";

export interface IExpressionBehavior {}

export interface IExpressionContainable<T> {
  contents: T[];
}

export interface IExpressionRangeSpecifiable<T> {
  from: T;
  to: T;
}

export interface ICalculationExpressionBehavior extends IExpressionBehavior, IExpressionContainable<ICalculationExpressionContent> {
  conditionalExpressionBehavior: IConditionalExpressionBehavior;
}

export interface ICalculationExpressionContent {
  kind: ExpressionReferenceKinds;
  reference: ICalculationExpressionObjectReference | number | ExpressionFunctionKinds;
  operator: ExpressionOperatorKinds;
  brackets: IExpressionContentBrackets;
  name?: string; // 設定UIで表示する名称（UIクラス内でセットする）
}

export interface ICalculationExpressionObjectReference extends ILinkedObjectSpecifiable {
  expressionKind?: ExpressionKinds;     // calculateの場合のみ指定.
  alternativeValue: number;
}

export interface IConditionalExpressionBehavior extends IExpressionBehavior, IExpressionContainable<IConditionalExpressionContent> {}

export interface IConditionalExpressionContent {
  reference: IConditionalExpressionObjectReference;
  operator: ExpressionOperatorKinds;
  value: string;
  brackets: IExpressionContentBrackets;
  logicalOperator: ExpressionLogicalOperatorKinds;
  presentation: IConditionalExpressionPresentation;
}

export interface IConditionalExpressionPresentation {
  kind: ExpressionReferenceKinds;  // 仕様上定義されてる日付は実際には利用されておらずExpressionReerenceKindsでケアできるので流用.
  reference: IConditionalExpressionObjectReference | string;
}

export interface IConditionalExpressionObjectReference extends ILinkedObjectSpecifiable {
  expressionKind?: ExpressionKinds;     // calculateの場合のみ指定.
  dateDurationKind?: DateDurationKinds; // calculate(DateDuration)の場合のみ指定.
}

export interface IDateDurationExpressionBehavior extends IExpressionBehavior, IExpressionRangeSpecifiable<ILinkedObjectSpecifiable> {
  kind: DateDurationKinds;
  isContainedFrom: boolean;
}

export enum DateDurationKinds {
  Days = 3,           // 日数.
  Weeks = 4,          // 週数.
  Years = 6,          // 年数(単位なし)
  Age = 7,            // 年齢(月日)
}

export interface ITimeSpanExpressionBehavior extends IExpressionBehavior, IExpressionRangeSpecifiable<ILinkedObjectSpecifiable> {
  kind: TimeSpanKinds;
}

export enum TimeSpanKinds {
  DayHourMinute = 5,  // 日時分.
  Minute = 8,         // 分.
  HourMinute = 9,     // 時分.
}

export interface IDateComparisonExpressionBehavior extends IExpressionBehavior, IExpressionContainable<IDateComparisonExpressionContent> {}

export interface IDateComparisonExpressionContent {
  reference: ILinkedObjectSpecifiable;
  operator: ExpressionOperatorKinds;
  name?: string; // 設定UIで表示する名称（UIクラス内でセットする）
}

export interface IUndefinedExpressionBehavior extends IExpressionBehavior {
  source: any;
}

export interface IExpressionContentBrackets {
  openCount: number;
  closeCount: number;
}

export enum ExpressionReferenceKinds {
  Object = 1,   // 連携オブジェクト.
  Fixed = 2,    // 固定値.
  Function = 3, // 関数.
}

export enum ExpressionFunctionKinds {
  Root = 1,
  NaturalLogarithm = 2,
}

export enum ExpressionOperatorKinds {
  Add = 1,
  Subtract = 2,
  Multiply = 3,
  Divide = 4,
  Power = 5,
  Root = 6,
  Modulo = 7,                 // 剰余.未使用？
  GreaterThan = 10,
  GreaterThanOrEqualTo = 11,
  LessThan = 12,
  LessThanOrEqualTo = 13,
  Euqal = 14,
  NotEqual = 15,
  Matched = 16,               // 文字列一致.
  Unmatched = 17,             // 文字列不一致.
}

export enum ExpressionLogicalOperatorKinds {
  None = 0,
  And = 1,
  Or = 2,
}
